import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DetalleVenta, Usuario, Venta } from 'src/app/model/index.model';
import { ApiService, WorkshoppingService } from 'src/app/service/index.service';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { ContenedorRegLogComponent } from '../contenedor-reg-log/contenedor-reg-log.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-contendor',
  templateUrl: './contendor.component.html',
  styleUrls: ['./contendor.component.scss'],
  providers: [ApiService, WorkshoppingService]
})
export class ContendorComponent implements OnInit {
  conf: any
  url: string = environment.configUrl;;

  proccess: boolean = false
  public cotizacion: number = 1;

  items: DetalleVenta[] = [];
  historial: any[] = [];
  item: Venta

  usuario: Usuario


  constructor(
    private http: HttpClient,
    private modalService: NgbModal,
    private wsdl: WorkshoppingService,
    private route: Router,
    private wsdlApi: ApiService) {
    this.usuario = JSON.parse(UturuncoUtils.getSession(UturuncoUtils.UC))
    this.item = new Venta()
  }

  async ngOnInit() {

    if (!this.usuario) {
      // Redirigir o mostrar modal login
      this.openModalLogin()
      return;
    } else {
      this.cargar()
    }

  }

  async eliminarCompra(item: Venta) {
    const confirmado = confirm(`¿Estás seguro de que querés cancelar la compra #${item.id}?`);
    if (!confirmado) return;

    try {
      this.proccess = true;
      const data = await this.wsdlApi.cancelarVenta(item.id, this.usuario.id);
      const res = JSON.parse(JSON.stringify(data));

      if (res.code == 200) {
        UturuncoUtils.showToas("Compra cancelada con éxito", "success");
        // Opcional: refrescar historial
        this.ObtenerCompras();
      } else {
        UturuncoUtils.showToas(res.msg, "error");
      }
    } catch (error) {
      UturuncoUtils.showToas("Error al cancelar la compra", "error");
    } finally {
      this.proccess = false;
    }
  }
  cerrarSesion() {
    UturuncoUtils.clearSession()
    this.route.navigate(['/']); // o la ruta que uses para ingresar
  }

  calcularTotal(): number {
    return this.wsdl.calculateTotal()
  }

  async ObtenerCompras() {
    try {
      this.proccess = true;
      let data = await this.wsdlApi.getCompras(this.usuario.id, 1, 100).then();
      const result = JSON.parse(JSON.stringify(data));

      this.historial = result.data.docs;
    } catch (error) {
      this.proccess = false;
    } finally {
      this.proccess = false;
    }
  }

  actualizarCarrito() {
    this.items = this.wsdl.detalle
    this.item.total = this.wsdl.calculateTotal()
  }

  zfill(number, width) {
    width -= number.toString().length;
    if (width > 0) {
      return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
    }
    return number + "";
  }

  async getCotizacion() {
    try {
      this.proccess = true;
      let data = await this.wsdlApi.getUsd().then();
      const result = JSON.parse(JSON.stringify(data));
      this.cotizacion = result.venta;
    } catch (error) {
      this.proccess = false;
    } finally {
      this.proccess = false;
    }
  }

  openModalLogin() {
    const modalRef = this.modalService.open(ContenedorRegLogComponent, {
      size: 'md',
      centered: true,
      keyboard: true       // permite cerrar con ESC
    });

    //modalRef.componentInstance.product = product;

    modalRef.result.then(
      result => {
        this.cargar()
        console.log('Modal cerrado con:', result);
      },
      reason => {
        console.log('Modal descartado con:', reason);
        this.route.navigate(["/"]);
      }
    );
  }

  async cargar() {
    await this.ObtenerCompras();
    await this.wsdl.registrarCliente();
    await this.wsdl.cargarCarrito();
    await this.actualizarCarrito();
    await this.http.get(this.url).subscribe(res => {
      this.conf = res;
      if (this.conf.dolar) {
        this.getCotizacion();
      } else {
        this.cotizacion = 1
      }
    });
  }

}
